const i18n = {
  appealFiles: {
    1: 'Прикреплённые файлы',
    0: 'Прымацаваныя файлы'
  },
  answerFiles: {
    1: 'Файлы ответа:',
    0: 'Файлы адказа:'
  },
  downloadAppealsFiles: {
    1: 'Скачать все файлы',
    0: 'Спампаваць усе файлы'
  },
  downloadAppealsZipFileName: {
    1: 'Файлы обращения №{0}',
    0: 'Файлы прыкладання №{0}'
  },
  promptTextForDownloadAppealsZipFile: {
    1: 'Файлы будут загружены .zip архивом.',
    0: 'Файлы будуць загружаны .zip архівам.'
  },
  additionalOrderMessageZipFileName: {
    1: 'Файлы ответа от {0}',
    0: 'Файлы адказу ад {0}'
  },
	signer: {
		1 : 'Подписант:\n{0}',
		0 : 'Падпісант:\n{0}'
	}
}

export default i18n
